/**
 * Custom Modal Logic for BIS Popup
 * Documentation: https://help.backinstock.org/article/2303-javascript-api
 * Custom Modal Logic for Appikon BIS Popup 
  */

const initializeBis = () => {
  initializeBisWidget();
  initializeBisPopup();
}

let activeBisTab = 0; // 0-email, 1-phone
const initializeBisWidget = () => {
  const buttonPhone = document.querySelector("#bis-phone");
  if (!buttonPhone) {
    console.log('------ No BIS Widget');
    return;
  }

  const messageBISSuccess = document.querySelector('.custom-bis-inline-form-success');
  const messageBISSError = document.querySelector('.custom-bis-inline-form-error');

  document.querySelector('#bis-email-tab').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#bis-email-tab').classList.add('active');
    document.querySelector('#bis-phone-tab').classList.remove('active');
    document.querySelector('#bis-tab-phone').classList.add('inline-form-hidden-tab');
    document.querySelector('#bis-tab-email').classList.remove('inline-form-hidden-tab');
    activeBisTab = 0;
  })

  document.querySelector('#bis-phone-tab').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#bis-email-tab').classList.remove('active');
    document.querySelector('#bis-phone-tab').classList.add('active');
    document.querySelector('#bis-tab-phone').classList.remove('inline-form-hidden-tab');
    document.querySelector('#bis-tab-email').classList.add('inline-form-hidden-tab');
    activeBisTab = 1;
  });
  
  const bisPhone = window.intlTelInput(buttonPhone,({
    initialCountry:"au",
    containerClass: "bis-phone-wrapper",
    utilsScript: "https://cdn.shopify.com/s/files/1/0995/4244/files/utils.js?v=1712992920"
  }));

  const showBisPhoneStatus = (state) => {
    const elem = document.querySelector('#bis-tab-phone .bis-form-warning');
    if (state)
      elem.style.display = 'none';
    else 
      elem.style.display = 'block';
  }

  const showBisEmailStatus = (state) => {
    const elem = document.querySelector('#bis-tab-email .bis-form-warning');
    if (state)
      elem.style.display = 'none';
    else 
      elem.style.display = 'block';
  }

  const updateBISMessage = (state) => {
    switch (state) {
      case 'success':
        messageBISSuccess.classList.add('active')
        messageBISSError.classList.remove('active')
        break;
      case 'error':
        messageBISSError.classList.add('active')
        messageBISSuccess.classList.remove('active')
        break;
      case'reset':
        messageBISSError.classList.remove('active')
        messageBISSuccess.classList.remove('active')
        break;
    }
  }

  document.querySelector('#custom-bis-inline-form-submit').addEventListener('click', async (e) => {
    e.preventDefault();
    updateBISMessage('reset');
    showBisPhoneStatus(true);
    showBisEmailStatus(true);

    //product Id
    const productId = document.querySelector("input[name='product-id']").value;
    
    //variant Id
    const variantId = document.querySelector(".ProductForm__Option  select[name='id']").value;


    let isValid = true;
    const phone = bisPhone.getNumber();
    const email = document.querySelector('#bis-tab-email input').value;

    const accepts_marketing = document.querySelector('#bis_accepts_marketing').checked;   

    if (activeBisTab === 1) {
      //Phone      
      isValid = bisPhone.isValidNumber();
      showBisPhoneStatus(isValid);      
    } else {
      // Email
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;      
      isValid = email.match(mailformat);
      isValid = !!isValid;
      showBisEmailStatus(isValid);      
    }

    if (!isValid) {
     return; 
    }

    try {
      const response = activeBisTab === 1?await BIS.create(null, variantId, productId, {accepts_marketing, phone_number: phone }):await BIS.create(email, variantId, productId, {accepts_marketing});
      if (response.status === 'OK') {
        messageBISSuccess.innerHTML = response.message;
        updateBISMessage('success');
        
      } else {
        let strError = '';

        Object.keys(response.errors).forEach(function(key, index) {
          console.log(key);
          strError = response.errors[key][0];
        });

        messageBISSError.innerHTML = strError;
        updateBISMessage('error');
      }
    } catch (error) {
      console.error('An error occured during custom-bis.js > formBIS.addEventListener("submit")', error)
    }
    
  });
  
}

const initializeBisPopup = () => {
    const buttonBIS = document.querySelector('.InterestTrigger')
    console.log('aaaaaaaaaaa');
    if (!buttonBIS) {
      console.log('------ No BIS Popup');
      return;
    }
    //document.querySelector('.ProductForm__Inventory').style.display = 'none';
    //document.querySelector('.ProductForm__BuyButtons').style.display = 'none';

    const popupBIS = document.querySelector('.InterestPopup')
    const buttonSubmit = document.querySelector('.InerestPopup__Submit')

    const buttonsClose = popupBIS.querySelectorAll('.InterestPopup__Close')
    
    const messageBISSuccess = popupBIS.querySelector('.bis-success')
    const messageBISSError = popupBIS.querySelector('.bis-error')
    const dropdownSelector = document.querySelector('select.bis-select')
    let selectedVariant;
  
    if (!popupBIS) {
      console.error('BIS Popup not found.')
      return
    }
  
    // Function to update the currently selected variant
    const updateCurrentVariant = () => {
      document.addEventListener("variant:changed", (e) => {
        var variant = e.detail.variant,
        previousVariant = e.detail.previousVariant;
        console.log(`[BIS] Variant Changed. Old:'${previousVariant.id}' => New:'${variant.id}'`);
        selectedVariant = variant.id.toString();

        document.querySelector('.ProductInterest__Tag').style.display = "block";
      });
    }
  
    const updateBISMessage = (state) => {
      switch (state) {
        case 'success':
          messageBISSuccess.classList.add('active')
          messageBISSError.classList.remove('active')
          break;
        case 'error':
          messageBISSError.classList.add('active')
          messageBISSuccess.classList.remove('active')
          break;
        case'reset':
          messageBISSError.classList.remove('active')
          messageBISSuccess.classList.remove('active')
          break;
      }
    }
  
    // Function to toggle popup visibility
    const togglePopup = (isVisible) => {
      updateBISMessage('reset')
      const pageOverlayElement = document.querySelector('.PopupOverlay');
      if (isVisible) {
        const selectElement = document.getElementById('bis-form').querySelector("select[name='variant']")
        for (let i = 0; i < selectElement.options.length; i++) {
          if (selectElement.options[i].value === selectedVariant) {
            selectElement.selectedIndex = i
            break
          }
        }
        dropdownSelector.addEventListener('change', () => {
          updateBISMessage('reset')
        })

        document.documentElement.classList.add('no-scroll');
        pageOverlayElement.classList.add('is-visible');
      } else {
        document.documentElement.classList.remove('no-scroll');
        pageOverlayElement.classList.remove('is-visible');
      }
      popupBIS.setAttribute('aria-hidden', !isVisible);
    }
  
  
    // Initialize selectedVariant as the Modal Loads
    // Sometimes the currentVariant is not selected when the page loads
    updateCurrentVariant() 
  
    buttonBIS.addEventListener('click', () => {
      togglePopup(true)
    })
  
    buttonsClose.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        togglePopup(false)
      })
    })
  
    buttonSubmit.addEventListener('click', async (e) => {
      e.preventDefault()

      const variant = document.getElementById('bis-form').querySelector("select[name='variant']").value;
      const email = document.getElementById('bis-form').querySelector("input[name='email']").value;
      const id = document.getElementById('bis-form').querySelector("input[name='id']").value;

    if (variant === '') {
        messageBISSError.innerHTML = 'Please select the variant option.'
        updateBISMessage('error')
        return;
      }
      if (email === '') {
        messageBISSError.innerHTML = 'Please input the email field.'
        updateBISMessage('error')
        return;
      }

      try {
        const response = await BIS.create(email, variant, id);
        if (response.status === 'OK') {
          updateBISMessage('success')
          setTimeout(() => {
            togglePopup(false);
            updateBISMessage('reset')
          }, 3000)
        } else {
          messageBISSError.innerHTML = response.errors.base[0]
          updateBISMessage('error')
        }
      } catch (error) {
        console.error('An error occured during custom-bis.js > formBIS.addEventListener("submit")', error)
      }
    })
   
  }
  
  document.addEventListener('DOMContentLoaded', initializeBis)